module.exports = __webpack_public_path__ + "static/imgBannerLanding-8bc67fb452d3afaaebb7d55e402d2c01.png";